import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';

import { ProductStatus } from './plan-picker.types';

@Pipe({
  name: 'rtPlanPickerProductCtaLabel',
  pure: true,
  standalone: true,
})
export class PlanPickerProductCtaLabelPipe implements PipeTransform {
  constructor(private i18n: I18nService) {}

  public transform(value: ProductStatus, isAssigned?: boolean): any {
    switch (value) {
      case ProductStatus.Owned:
        return this.i18n.translate('app.pricing.plan_picker.your_current_plan');
      default:
        return this.i18n.translate('app.common.get_in_touch');
    }
  }
}
